import { useCallback } from 'react';
import { generatePath } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { FORM_ERROR } from 'final-form';
import RegistrationForm from 'app/components/RegistrationForm';
import selectAppState from 'app/store/selector';
import createStyles from '@guestyci/foundation/esm/createStyles/createStyles';
import _extends from '@babel/runtime/helpers/esm/extends';
import TextField from '@guestyci/foundation/TextField';
import { Col } from '@guestyci/foundation/Layout';
import * as appRoutes from 'app/routes';
import AppStyle from 'app/Styles';
import theme from '@guestyci/foundation/theme/defaultTheme';
import { pick } from 'lodash';
import { saveSmartLink as saveSmartLinkAction } from 'app/store/app-state.slice';
import { FIELD_NAME } from 'app/constants/form-fields';
import errorCodes from 'app/constants/error-codes';

const useStyles = createStyles(() =>
  _extends(AppStyle, {
    root: {
      width: '100%',
      maxWidth: theme.breakpoints.values.md,
      margin: '0 auto',
    },
  }));

function RegistrationPage() {
  const classes = useStyles();
  const state = useSelector(selectAppState);
  const history = useHistory();
  const dispatch = useDispatch();

  const handleSuccess = useCallback(
    (response) => {
      window.fbq?.('trackCustom', 'FreeTrialGhosts', {
        Registration: 'FreeTrialGhosts',
      });

      window.dataLayerMain?.push?.({
        event: 'auto-event',
        ga_category: 'GFA Free Trial',
        ga_action: 'Successful registration',
      });

      dispatch(saveSmartLinkAction(pick(response, ['link', 'mobileLink'])));

      if (state.isRegularSignUp) {
        const pathname = generatePath(appRoutes.VERIFY_EMAIL, {
          email: state.email,
        });

        history.replace(pathname);
      }
      if (state.isGoogleSignUp) {
        history.replace(appRoutes.ACTIVATE);
      }
    },
    [dispatch, history, state.email, state.isGoogleSignUp, state.isRegularSignUp]
  );

  const handleFailed = useCallback(
    (response) => {
      const formErrors = {};

      switch (response.errorCode) {
        case errorCodes.USER_EXIST: {
          history.push(appRoutes.EXISTING_EMAIL);
          break;
        }

        case errorCodes.PROMOTION_CODE_INVALID: {
          Object.assign(formErrors, {
            [FIELD_NAME.PROMO_CODE]: 'Your promotion code is not valid',
          });
          break;
        }

        default: {
          Object.assign(formErrors, {
            [FORM_ERROR]: response.errorMessage || 'Registration failed',
          });
        }
      }

      return formErrors;
    },
    [history]
  );

  if (!state.email && !state.googleIdToken) {
    return <Redirect to={`${appRoutes.ROOT}${history.location.search}`} />;
  }

  return (
    <div className={classes.root} id="registration-page-container">
      <Col span={12} spacing={12}>
        <Col spacing={2}>
          <TextField
            align="center"
            className={classes.pageHeading}
            id="registration-page-heading"
          >
            Begin your 14 day free trial today!
          </TextField>
          <TextField
            align="center"
            variant="h3"
            className="font-weight-light"
            id="registration-page-description"
          >
            No credit card, set up fee or commitment required. Cancel anytime.
          </TextField>
        </Col>

        <RegistrationForm onSuccess={handleSuccess} onError={handleFailed} />
      </Col>
    </div>
  );
}

export default RegistrationPage;
